import { render, staticRenderFns } from "./czrz.vue?vue&type=template&id=73b31cbf&scoped=true"
import script from "./czrz.vue?vue&type=script&lang=js"
export * from "./czrz.vue?vue&type=script&lang=js"
import style0 from "./czrz.vue?vue&type=style&index=0&id=73b31cbf&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b31cbf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73b31cbf')) {
      api.createRecord('73b31cbf', component.options)
    } else {
      api.reload('73b31cbf', component.options)
    }
    module.hot.accept("./czrz.vue?vue&type=template&id=73b31cbf&scoped=true", function () {
      api.rerender('73b31cbf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/sysConfig/czrz.vue"
export default component.exports